import React, { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import styled from "styled-components";

const PaginationSection = (props) => {
  const {
    productListCount = 0,
    pageSize = 0,
    offset = 0,
    updateURI = () => {},
  } = props;

  console.log("productListCount", props);

  const [page, setPage] = useState(null);
  const [pageCount, setPageCount] = useState(null);
  const handleChange = (event, value) => {
    console.log("value", value);
    updateURI(value);
  };

  useEffect(() => {
    const pagesCount = productListCount / pageSize;
    const currPage = offset || 1;
    setPageCount(Math.ceil(pagesCount));
    setPage(currPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1rem;

  `

  return (
    
     <PaginationContainer> 
       <Stack spacing={22} style={{borderColor:'#fff'}}>
        <Pagination
          count={pageCount}
          page={page}
          style={{borderColor:'#fff',boxShadow:'none'}}

          color="primary"
          onChange={handleChange}
          sx={{ alignSelf: "center", padding: 4 }}
          size="medium"
        />

      </Stack>
     </PaginationContainer>

  );
};
export default PaginationSection;
